export const APPLY_COUPON_FORM = 'ApplyCouponForm'

export const APPLY_COUPON_FORM_FIELD_NAME = 'couponCode'
